<template>
    <div class="header">
        <div style="float: right; margin-right:50px; margin-top: 20px; margin-bottom: 5px;">
            <el-button type="success" round @click="ClickMeToAdd">新建课程</el-button>
        </div>
        <el-table
        :data="courseList"
        border
        style="width: 1170px; margin: 0 auto;"
        min-height="200"
        max-height="500">
        <el-table-column
            prop="createTime"
            label="创建日期"
            width="234">
        </el-table-column>
        <el-table-column
            prop="courseName"
            label="课程名称"
            width="234">
        </el-table-column>
        <el-table-column
            prop="price"
            label="课程价格"
            width="234">
        </el-table-column>
        <el-table-column
            prop="participants"
            label="购买人数"
            width="234">
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="233">
            <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="ClickMeToUpdate(scope.row)" type="text" size="small">编辑</el-button>
            </template>
        </el-table-column>
        </el-table>
  </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        methods: {
            handleClick(row) {
                let routeData = this.$router.resolve({
                    name:'programmes',
                    params: { // 只需要传 题目的题号和题目名字过去
                        id: row.id,
                    }
                });
                window.open(routeData.href, '_blank');
            },
            ClickMeToUpdate(row) {
                console.log(row)
                let routeData = this.$router.resolve({
                    path:'/AboutCourse',
                    query: { // 只需要传 题目的题号和题目名字过去
                        id: row.id,
                        words: row.words,
                        course_name: row.courseName,
                        photo: row.photo,
                        price: row.price,
                        course_about: row.courseAbout
                    }
                });
                window.open(routeData.href, '_blank');
            },
            ClickMeToAdd() {
                let routeData = this.$router.resolve({
                    path:'/AboutCourse',
                });
                window.open(routeData.href, '_blank');
            }
        },
        data() {
            return {
                jsonList:'',
                courseList:[],
            }
        },
        mounted() {
            const vue = this
            $.ajax({
                url:'https://app6132.acapp.acwing.com.cn/api/course/read/list/',
                type:'get',
                success(resp) {
                    if (resp.error_message === 'success') {
                        // console.log("课程接受成功了")
                        vue.jsonList = resp.courseList
                        vue.courseList = JSON.parse(vue.jsonList)
                        // console.log(vue.courseList)
                    }
                },
                error(resp) {
                    console.log("课程接受彻底失败了, resp == >", resp)
                }
            })
        }
    }
</script>

<style scoped>
.header {
    border: 1px solid lightgrey;
}
</style>